import classNames from 'classnames';
import React from 'react';
import { useSwipeable } from 'react-swipeable';

import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import { ModalDialogHeaderProps } from '../ModalDialogTypes';

const ModalHeader: React.FC<
    Omit<ModalDialogHeaderProps, 'headerContent' | 'title' | 'description' | 'id'> & React.PropsWithChildren
> = ({ children, headerClassName, hideCloseButton = false, onClose, type, onCloseDownSwipe }) => {
    const handlers = useSwipeable({
        onSwipedDown: () => onCloseDownSwipe && onClose?.(),
    });

    return (
        <div
            className={classNames('sgw-modal-dialog__header', headerClassName, {
                'hidden-close-button': hideCloseButton,
            })}
            {...handlers}
        >
            {type === 'standard' ? (
                <>
                    <div className="sgw-modal-dialog__header-items">{children}</div>
                    <div className="sgw-modal-dialog__header-close-button--align-end">
                        {!hideCloseButton && (
                            <IconButton
                                screenReaderText="Lukk"
                                data-track-id="close-modal-icon-button"
                                icon={IconTypes.KRYSS_24}
                                onClick={onClose}
                            />
                        )}
                    </div>
                </>
            ) : (
                <>
                    <div className="sgw-modal-dialog__header-close-button">
                        {!hideCloseButton && (
                            <IconButton
                                screenReaderText="Tilbake"
                                data-track-id="return-modal-icon-button"
                                icon={IconTypes.BACK}
                                onClick={onClose}
                            />
                        )}
                    </div>
                    <div className="sgw-modal-dialog__header-items__sub">{children}</div>
                </>
            )}
        </div>
    );
};

const ModalDialogHeader: React.FC<ModalDialogHeaderProps> = ({ headerContent, borderForHeaderAndFooter, ...rest }) => {
    if (headerContent) {
        return (
            <ModalHeader
                {...rest}
                headerClassName={classNames(rest.headerClassName, 'custom-header', {
                    'with-border': borderForHeaderAndFooter,
                })}
            >
                {headerContent}
            </ModalHeader>
        );
    }

    return <ModalHeader {...rest} />;
};

export default ModalDialogHeader;
